// @flow
import React from 'react'
import I18n from 'i18n-react'
import { humanizer } from 'devx-js-utilities'

import Images from '../../../Themes/Images'
import { perUnitOfQuality } from '../../ContentFunctions'

import ColumnTypeSuriIndexPillow from './ColumnTypeSuriIndexPillow'

// types
import type { ColumnTypeDefaultProps } from './ColumnTypeDefault'

const ColumnTypeSuriIndexMerged = (props: ColumnTypeDefaultProps) => {
  const suriIndex = props.quote.suriIndex.value

  if (props.quote.calculatorName === 'CarPillow') {
    return <ColumnTypeSuriIndexPillow {...props} />
  }
  return (
    <div
      className={props.columnConfig.classNames.wrapper}
      key={`quote-insuranceCompany-suri-index-${props.columnConfig.key}-${props.quote.id}`}
    >
      <span className={props.columnConfig.classNames.valueWrapper}>
        <strong className={props.columnConfig.classNames.value}>{suriIndex}</strong>
        <img alt='Suri index' className={props.columnConfig.classNames.image} src={Images.suriIndexImage} width='30'/>
      </span>
      {props.showPrice &&
      <div className={props.columnConfig.classNames.priceWrapper}>
        <strong className={props.columnConfig.classNames.priceValue}>
          {humanizer.csNumber(perUnitOfQuality(props.quote.price, suriIndex))}&nbsp;{I18n.translate('general.currency')}
        </strong>
        <small className={props.columnConfig.classNames.quality}>{I18n.translate('general.perUnitOfQuality')}</small>
      </div>}
    </div>
  )
}

export default ColumnTypeSuriIndexMerged
